import { Box, Skeleton } from "@mui/material"

export default function CustomerListSkeleton({ rows = 10 }) {
    return (
        <Box sx={{ width: '100%' }}>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <Box
                    key={rowIndex}
                    sx={{
                        display: 'flex',
                        gap: 2,
                        px: 2,
                        py: 1.5,
                        alignItems: 'center',
                        borderBottom: (theme) =>
                            `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={24}
                        sx={{ borderRadius: 1 }}
                    />
                </Box>
            ))}
        </Box>
    )
}

